
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/profile/referral",
      function () {
        return require("private-next-pages/[locale]/profile/referral.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/profile/referral"])
      });
    }
  